// libs
import * as z from 'zod'
// schemas
import { ChartConfigSchema, FieldMeta } from 'schemas/chartConfig'

// How the settings drawer reads the chart config's schema: as JSON Schema, a field per property

// The `type` of a JSON Schema node, as the standard names it
export enum JsonSchemaType {
  Object = 'object',
  Array = 'array',
  String = 'string',
  Number = 'number',
  Integer = 'integer',
  Boolean = 'boolean',
  Null = 'null'
}

// A node of the JSON Schema, as the settings drawer reads it
export interface ChartSchemaNode extends FieldMeta {
  type?: JsonSchemaType
  title?: string
  description?: string
  enum?: (string | number)[]
  default?: unknown
  minimum?: number
  maximum?: number
  maxLength?: number
  maxItems?: number
  pattern?: string
  items?: ChartSchemaNode
  anyOf?: ChartSchemaNode[]
  properties?: Record<string, ChartSchemaNode>
}

// What a config may be sent as: every default filled in is optional
const CHART_CONFIG_JSON_SCHEMA = z.toJSONSchema(ChartConfigSchema, { io: 'input' }) as ChartSchemaNode

export const CHART_TRANSFORM_SCHEMA = CHART_CONFIG_JSON_SCHEMA.properties.transform
export const CHART_DISPLAY_SCHEMA = CHART_CONFIG_JSON_SCHEMA.properties.display
